<template>
	<div>
		<AppHeader title="회원 탈퇴" is-history></AppHeader>
		<AppContent>
			<UserLeaveDetail></UserLeaveDetail>
		</AppContent>
		<AppFooter></AppFooter>
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppContent from '@/components/common/AppContent';
import AppFooter from '@/components/common/AppFooter';

import UserLeaveDetail from '@/components/UserLeaveDetail';

export default {
	components: {
		AppHeader,
		AppContent,
		AppFooter,
		UserLeaveDetail,
	},
};
</script>
